import { Api } from "../ApiConfig";
import { ApiException } from "../ApiException";
import { getErrorMessage } from "../../../utils/utils";

interface infoToApiType {
  id?: string;
  projectId?: string | null;
  unavailabilityId?: string | null;
  projectName?: string | null;
  startDate: Date;
  endDate: Date;
  allocationTime: number;
  monthAllocationHours: number;
  isMonthAllocation: boolean;
  allocationPercentage?: number;
  isBillable: boolean;
  resources: { id: string, name: string }[],
  linkId: string | null,
  details: string,
  isProjection?: boolean;
  opportunityDetails?: string;
  opportunityLink?: string;
  ignoreBlocks?: boolean;
}

export const searchAllocations = async (
  skip: number = 0,
  take: number = 500,
  allocationFilterBy: number = 0,
  filterText: string = '',
  ids: string[] | undefined = undefined,
  startDate: Date | undefined = undefined,
  endDate: Date | undefined = undefined
) => {
  const date = new Date();
  if (!startDate)
    startDate = new Date(date.getFullYear(), date.getMonth(), 1);

  if (!endDate)
    endDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);

  let infoToApi

  if (ids) {
    infoToApi = {
      ids,
      skip,
      take,
      allocationFilterBy,
      filterText,
      startDate,
      endDate
    }
  } else {
    infoToApi = {
      skip,
      take,
      allocationFilterBy,
      filterText,
      startDate,
      endDate
    }
  }

  try {

    const { data } = await Api.post(`/api/ProjectResourceAllocation/SearchAllocations`, infoToApi)

    return data

  } catch (error) {
    throw new ApiException(getErrorMessage(error, 'Erro ao buscar as Alocações'))
  }
}

export const getProjectResourceAllocationById = async (projectAllocationId: string) => {

  try {

    const { data } = await Api.get(`/api/ProjectResourceAllocation/GetProjectResourceAllocationById?projectAllocationId=${projectAllocationId}`)

    return data

  } catch (error) {
    throw new ApiException(getErrorMessage(error, 'Erro ao buscar a Alocação'))
  }
}


export const addOrUpdateProjectResourceAllocation = async (infoToApi: infoToApiType) => {

  try {

    const { data } = await Api.post(`/api/ProjectResourceAllocation/AddOrUpdateProjectResourceAllocation`, infoToApi)

    return data

  } catch (error) {
    const message = 'Erro ao criar ou atualizar Alocação';
    throw new ApiException(getErrorMessage(error, message));
  }
}

export const hasBlockedDates = async (infoToApi: {
  resources: { id: string; name: string }[];
  startDate: string;
  endDate: string;
}) => {
  try {
    const { data } = await Api.post(
      `/api/ProjectResourceAllocation/HasBlockedDates`,
      infoToApi
    );
    return data;
  } catch (error) {
    const message = 'Erro ao verificar datas bloqueadas';
    throw new ApiException(getErrorMessage(error, message));
  }
};


export const deleteProjectResourceAllocation = async (id: string) => {

  try {

    const response = await Api.delete(`/api/ProjectResourceAllocation/DeleteProjectResourceAllocation/${id}`)

    return response

  } catch (error) {
    throw new ApiException(getErrorMessage(error, 'Erro ao excluir a Alocação'))
  }
}


export const deleteAllocationByProjectAndResource = async (projectId: string, resourceId: string) => {
  try {
    const { data } = await Api.delete(`/api/ProjectResourceAllocation/DeleteResourceFromProject?projectId=${projectId}&resourceId=${resourceId}`)
    return data
  } catch (error) {
    throw new ApiException(getErrorMessage(error, 'Erro ao excluir a Alocação'))
  }
}

export const deleteProjectResourceAllocationByLinkIdResourceId = async (linkId: string) => {
  try {
    const { data } = await Api.delete(`/api/ProjectResourceAllocation/DeleteProjectResourceAllocationByLinkIdResourceId`, {
      params: {
        linkId,
      },
    });
    return data
  } catch (error) {
    throw new ApiException(getErrorMessage(error, 'Erro ao excluir a Alocação'))
  }
}

export const hasFutureAllocation = async (resourceId: string) => {
  try {
    const { data } = await Api.get(`/api/ProjectResourceAllocation/HasFutureAllocation/${resourceId}`);
    return data;
  } catch (error) {
    const message = 'Erro ao verificar alocações futuras';
    throw new ApiException(getErrorMessage(error, message));
  }
};

